export default {
  APP_IS_TEMPORARILY_UNAVAILABLE: false,
  GOOGLE: {
    GA_TRACKING_CODE: process.env.REACT_APP_GA_TRACKING_CODE,
  },
}
